import React, { useState } from 'react';
import { ShoppingBagIcon, ShirtIcon, HomeIcon, UsersIcon } from 'lucide-react';
import Button from './Button';
import Wizard from './Wizard';
import { useTranslation } from '../i18n/useTranslation';
const Solutions = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const {
    t
  } = useTranslation();
  return <section id="solutions" className="py-16 bg-white" data-id="element-2222">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2223">
        <div className="text-center mb-12" data-id="element-2224">
          <h2 className="text-3xl font-bold mb-4" data-id="element-2225">
            {t('sections.solutions.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-2226">
            {t('sections.solutions.subtitle')}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-2227">
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-2228">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2229">
              <ShoppingBagIcon className="h-8 w-8 text-primary" data-id="element-2230" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-2231">
              {t('sections.solutions.electronics.title')}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-2232">
              {t('sections.solutions.electronics.description')}
            </p>
            <ul className="space-y-2 mb-6" data-id="element-2233">
              {t('sections.solutions.electronics.items', {
              returnObjects: true
            }).map((item, index) => <li key={index} className="text-gray-600 text-sm" data-id="element-2234">
                  • {item}
                </li>)}
            </ul>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2235">
              {t('buttons.learnMore')}
            </Button>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-2236">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2237">
              <ShirtIcon className="h-8 w-8 text-primary" data-id="element-2238" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-2239">
              {t('sections.solutions.fashion.title')}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-2240">
              {t('sections.solutions.fashion.description')}
            </p>
            <ul className="space-y-2 mb-6" data-id="element-2241">
              {t('sections.solutions.fashion.items', {
              returnObjects: true
            }).map((item, index) => <li key={index} className="text-gray-600 text-sm" data-id="element-2242">
                  • {item}
                </li>)}
            </ul>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2243">
              {t('buttons.learnMore')}
            </Button>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-2244">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2245">
              <HomeIcon className="h-8 w-8 text-primary" data-id="element-2246" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-2247">
              {t('sections.solutions.home.title')}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-2248">
              {t('sections.solutions.home.description')}
            </p>
            <ul className="space-y-2 mb-6" data-id="element-2249">
              {t('sections.solutions.home.items', {
              returnObjects: true
            }).map((item, index) => <li key={index} className="text-gray-600 text-sm" data-id="element-2250">
                  • {item}
                </li>)}
            </ul>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2251">
              {t('buttons.learnMore')}
            </Button>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-card border border-gray-100" data-id="element-2252">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2253">
              <UsersIcon className="h-8 w-8 text-primary" data-id="element-2254" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-2255">
              {t('sections.solutions.agency.title')}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-2256">
              {t('sections.solutions.agency.description')}
            </p>
            <ul className="space-y-2 mb-6" data-id="element-2257">
              {t('sections.solutions.agency.items', {
              returnObjects: true
            }).map((item, index) => <li key={index} className="text-gray-600 text-sm" data-id="element-2258">
                  • {item}
                </li>)}
            </ul>
            <Button variant="outline" fullWidth onClick={() => setIsWizardOpen(true)} data-id="element-2259">
              {t('buttons.learnMore')}
            </Button>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-2260">
          <Button variant="primary" size="lg" onClick={() => setIsWizardOpen(true)} data-id="element-2261">
            {t('buttons.findSolution')}
          </Button>
        </div>
      </div>
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-2262" />
    </section>;
};
export default Solutions;